let cachedCanvas

export default function getTextWidth(text, el, canvas) {
	if (!el) {
		return null
	}

	if (!canvas) {
		if (!cachedCanvas) {
			cachedCanvas = document.createElement('canvas')
		}
		canvas = cachedCanvas
	}

	const context = canvas.getContext('2d')
	if (!context) {
		return null
	}

	const styles = window.getComputedStyle(el)
	let font = styles.font

	if (!font) {
		const sizing = `${styles.fontSize} / ${styles.lineHeight} ${styles.fontFamily}`
		font = `${styles.fontStyle} ${styles.fontVariant} ${styles.fontWeight} ${sizing}`
	}

	context.font = font
	return context.measureText(text).width
}
